import React from "react";
import { Box, Typography } from "@material-ui/core";

const TabPanel = (props) => {

    const { children, value, index,padding=3, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
                <Box p={padding}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
        </div>
    );
}

export default TabPanel;